import {CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';

import {Observable, of} from 'rxjs';
import {select, Store} from '@ngrx/store';
import {catchError, filter, switchMap, take, tap} from 'rxjs/operators';

import {ApplicationState} from '../../application-state/store';
import {CustomerAccountsActions} from '../store';
import {CustomerAccountsSelectors} from '../store/selectors';

@Injectable()
export class CustomerAccountsLoadedGuard implements CanActivate {

  constructor(private store: Store<ApplicationState>) {
  }

  canActivate(): Observable<boolean> {

    return this.loadCustomerAccounts().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  loadCustomerAccounts() {

    return this.store.pipe(
      select(CustomerAccountsSelectors.isLoaded),
      tap((loaded: boolean) => {
        if (!loaded) {
          this.store.dispatch(CustomerAccountsActions.ReadCustomerAccounts({page: 1}));
        }
      }),
      filter(loaded => loaded),
      take(1)
    );
  }
}
